import { Query } from '@farfetched/core';
import { createEvent, EventCallable, sample } from 'effector';
import { AccountReportRegistryModel } from 'entities/account';
import { createDownloadAccountReportQuery, DownloadAccountReportQueryParams } from 'shared/api';

export type ExportReportAccountsModel = {
	exportButtonClicked: EventCallable<void>;
	downloadAccountReportQuery: Query<DownloadAccountReportQueryParams, void, unknown, null>;
};

export const createExportReportAccountsModel = (
	model: AccountReportRegistryModel,
): ExportReportAccountsModel => {
	const downloadAccountReportQuery = createDownloadAccountReportQuery();

	const exportButtonClicked = createEvent();

	sample({
		clock: exportButtonClicked,
		source: model.model.$filters,
		fn: (filters) => filters,
		target: downloadAccountReportQuery.start,
	});

	return {
		downloadAccountReportQuery,
		exportButtonClicked,
	};
};
